// skeleton/app/src/app/dashboard/dashboard.component.ts

import { Component, OnInit } from '@angular/core';
import { KeyValueOpt } from '../shared/models/keyvalue.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ButtonSize, ButtonStyle, ButtonType, ButtonColors } from '../shared/components/inputs/button/button.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { NotificationService } from '../shared/services/notifications.service';
import { Constants } from '../shared/constants';
import { SurveyModel } from './dashboard.model';
import { CardModel } from '../shared/components/view/card/card.model';
import { Store, select } from '@ngrx/store';
import { IDashboardState } from './store/state/dashboard.state';
import { SetUserFavorites, SetUserSurveys, SetTemplates } from './store/actions/dashboard.actions';
import { selectUserSurveys } from './store/selectors/dashboard.selector';
import { CardService } from '../shared/components/view/card/card.service';
import { ParamService } from '../shared/services/param.service';
//import { CreateSurvey } from '../shared/components/page/page.model';
//import { AppGlobals } from './app.global';
import { AppGlobals } from '../app.global';
import { UserServiceService } from '../user/survey-main/service/user-service.service';
import { UserModel, UserGroupModel } from '../admin/models/group.model';
import { CommonModule } from '@angular/common';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { CreateSurvey } from '../shared/components/page/page.model';
import { MenuNavbarComponent } from '../shared/components/menu-navbar/menu-navbar.component';
import * as roleConfiguration from 'src/app/configuration/roleconfiguration';
import { MenubarService } from '../shared/services/menunavbar.services';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [AppGlobals],
  standalone: false
})
export class DashboardComponent implements OnInit {
  Isdataloaded = true;

  navLinkList: Array<KeyValueOpt<string, string, boolean>> = [
    { key: "Surveys/Assessments", value: "mysurveys", opt: true },
    { key: "My Favorites", value: "favorites", opt: false },
    { key: "Templates", value: "templates", opt: false }
  ];

  constants: Constants = new Constants();
  btnLarge = ButtonSize.Large;
  btnPlus = ButtonStyle.PlusIcon;
  btnRnd = ButtonType.Round;
  btnColor = ButtonColors.Blue;

  mySurveyList: CardModel[] = [];
  myFavList: CardModel[] = [];
  myTemplateList: CardModel[] = [];

  isAdmin: boolean = false;
  isRespondent: boolean = false;
  isDesigner: boolean = false;

  user: UserGroupModel;

  filteredMenulist;
  // userTypeID = 0;
  private isExist = false;
  CombinedMenulist: { tab: string; icon: string; navigateUrl: string; sequence: number; }[];

  constructor(
    private menubarService: MenubarService,
    private router: Router,
    private globalSessionHandler: GlobalsessionhandlerService,
    private baseHttpService: BaseHttpService,
    private notificationService: NotificationService,
    private store: Store<IDashboardState>,
    private cardservice: CardService,
    private paramservice: ParamService,
    private _global: AppGlobals,
    private userService: UserServiceService,
    private storage: StorageService
  ) {
    paramservice.changeEmitted$.subscribe(text => {
      this.Isdataloaded = text;
    });
  }

  ngOnInit() {
    this.Getaccess();

    //Select tab on default load
    this.navLinkList.forEach((item) => {
      // Existing behavior used sessionStorage; Asset uses StorageService
      let url = this.storage.get("CurrentUrl");
      if (url != null && url.length > 0) { // added for user activity log redirection
        if (url.includes(item.value)) {
          item.opt = true;
        } else {
          item.opt = false;
        }
      } else { // existing code
        if (this.router.url.includes(item.value)) {
          item.opt = true;
        } else {
          item.opt = false;
        }
      }
    });

    this.getDashboardSurveys();

    this.userService.currentUser.subscribe((message: UserGroupModel) => {
      this.user = message;

      // this._global.organizationId=message.organizationId;

      if (this.user.userTypeId == "1") {
        this.isAdmin = true;
      }
      if (this.user.userTypeId == "2") {
        this.isDesigner = true;
      }
      if (this.user.userTypeId == "3") {
        this.isRespondent = true;
      }
    });
  }

  selectedTab(itemId: string) {
    this.paramservice.Parameterpass(null);

    this.navLinkList.forEach((item) => {
      if (item.key === itemId) {
        item.opt = true;
      } else {
        item.opt = false;
      }
    });
  }

  navigateCreate(event: any) {
    this.globalSessionHandler.setSurveyId("");
    this.globalSessionHandler.setSurveyStatus("");
    this.cardservice.tempholdSurveyData(new CreateSurvey());
    this.cardservice.getSurveyDetails(new CreateSurvey());
    this.globalSessionHandler.SetESignReq(false);
    this.router.navigate(["/create"]);
    this.paramservice.Parameterpass("CREATE");
  }

  getDashboardSurveys() {
    this.mySurveyList = [];
    this.myTemplateList = [];

    this.baseHttpService.get(this.constants.getUserDashboard).subscribe((dt: SurveyModel[]) => {
      if (dt.length != 0) {
        let mySurveys = dt.sort((a, b) => (a.createdDate < b.createdDate) ? 1 : -1);

        for (let h = 0; h < mySurveys.length; h++) {
          let card = new CardModel();
          card.id = mySurveys[h].surveyId;
          card.cardBody = mySurveys[h].description;
          card.cardTitle = mySurveys[h].name;
          card.isFavourite = <boolean>(<any>mySurveys[h].isFavourite);
          card.surveyResults = mySurveys[h].status.toLowerCase() === "d" ? "DRAFT" : mySurveys[h].resultsCount.toString();
          card.status = mySurveys[h].status.toUpperCase();
          card.resultsCount = mySurveys[h].resultsCount;
          card.isMultipleResponseAllowed = mySurveys[h].isMultipleResponseAllowed;
          card.inprogressCount = mySurveys[h].inprogressCount;

          card.accessLevel = mySurveys[h].accessLevel;
          card.createdDate = mySurveys[h].createdDate;
          card.surveyGroupName = mySurveys[h].surveyGroupName;
          card.surveyGroupId = mySurveys[h].surveyGroupId;
          card.isArchived = mySurveys[h].isArchived;
          card.isREResponse = <boolean>(<any>mySurveys[h].isREResponse);
          card.isCPResponse = <boolean>(<any>mySurveys[h].isCPResponse);
          card.IsGroupOwner = mySurveys[h].isGroupOwner;
          card.IsSharedWithOwn = mySurveys[h].isSharedWithOwn;
          card.IsWorkflow = mySurveys[h].isWorkflow;
          card.IsWFShared = mySurveys[h].isWFShared;
          card.isLoginRequired = mySurveys[h].isLoginRequired;
          card.dueDaysCount = mySurveys[h].dueDaysCount;
          card.dueDate = mySurveys[h].dueDate;
          card.isWfPublished = mySurveys[h].isWfPublished;
          card.isOverdue = mySurveys[h].isOverdue;
          card.isOverdueAccessAllowed = mySurveys[h].isOverdueAccessAllowed;

          if (card.IsWorkflow && !card.isWfPublished) {
            card.surveyResults = 'DRAFT';
          }

          card.isAssigned = mySurveys[h].isAssigned;
          this.mySurveyList.push(card);
        }

        if (mySurveys.length <= 0 && this._global.rendredOnLogin == true && !this.isRespondent) {
          this._global.rendredOnLogin = false;
          this.selectedTab("Templates");
          this.router.navigate(["/dashboard/templates"]);
        } else {
          this._global.rendredOnLogin = false;
        }

        Object.assign(this.myFavList, this.mySurveyList.filter(x => x.isFavourite));
        this.store.dispatch(new SetUserFavorites(this.myFavList));
        this.store.dispatch(new SetUserSurveys(this.mySurveyList));
        this.cardservice.getUserSurvey(mySurveys);
      } else {
        if (this._global.rendredOnLogin == true && !this.isRespondent) {
          this._global.rendredOnLogin = false;
          this.selectedTab("Templates");
          this.router.navigate(["/dashboard/templates"]);
        }
        this.store.dispatch(new SetUserFavorites(this.myFavList));
        this.store.dispatch(new SetUserSurveys(this.mySurveyList));
      }
    });
  }

  Getaccess() {
    this.userService.currentUser.subscribe((result: UserGroupModel) => {
      this.user = result;

      if (this.user.userTypeId != null && this.user.userTypeId != "") {
        let addmenuList = roleConfiguration.AdminMenuList; // Bind all menu list from file
        let usertypeid = this.user.userTypeId; // Check logged in user id
        this.filteredMenulist = addmenuList.filter(p => p.roleid == usertypeid); // Bind Menu list based on userloginID
        this.filteredMenulist = this.filteredMenulist.filter((item, i, ar) => ar.indexOf(item) === i); // Check duplicate bind
        this.filteredMenulist.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1); // display icon sequence wise
        this.menubarService.tempholdMenuData(this.filteredMenulist);
        return;
      } else {
        this.menubarService.tempholdMenuData([]);
      }
    });
  }
}
